export default __webpack_public_path__ + "static/media/2.3-CucumberF.e5841704.jpg";